<template>
  <div class="">
    <div class="columns is-mobile is-centered is-vcentered">
      <div class="column is-3">
        <b-image
          :src="require('@/assets/logo.svg')"
          alt="qlipmark"
          class="logo"
        />
      </div>
      <div class="column is-flex-grow-0 has-text-primary logo-text">
        qlipmark
      </div>
    </div>

    <p class="title is-3">
      Sign Up
    </p>

    <form @submit.prevent="onSubmit">
      <b-field>
        <b-input
          v-model="form.email"
          type="email"
          placeholder="Email"
          size="is-medium"
          autofocus=""
          required
        />
      </b-field>

      <b-field>
        <b-input
          v-model="form.password"
          type="password"
          placeholder="Password"
          size="is-medium"
          required
        />
      </b-field>

      <b-field>
        <b-input
          v-model="form.passwordConfirmation"
          type="password"
          placeholder="Password Confirmation"
          size="is-medium"
          required
        />
      </b-field>
      <button class="button is-block is-primary is-medium is-fullwidth submit-button">
        Sign Up
      </button>
    </form>
    <p class="mt-5 has-text-centered has-text-grey">
      <router-link :to="{name: 'Login'}">
        Login
      </router-link>
      &nbsp;-&nbsp;
      <router-link :to="{name: 'SendResetPassword'}">
        Recover
      </router-link>
    </p>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'

export default {
  data () {
    return {
      form: {
        email: '',
        password: '',
        passwordConfirmation: ''
      }
    }
  },
  validations: {
    form: {
      email: { required, email },
      password: { required },
      passwordConfirmation: { required }
    }
  },
  methods: {
    ...mapActions({
      signup: 'auth/signup'
    }),
    onSubmit () {
      this.signup(this.form).then(() => this.$router.push({name: 'Home'})).catch(() => {})
    }
  }
}
</script>

<style lang="scss">
  
</style>
